import { DisplayAdProvider } from '../providers/displayAdProvider.js';
import { dataLayer } from '@weatherbug/common';
const {
    getAdTargetingParameters
} = dataLayer.actions;

export const REGISTER_DISPLAY_AD = 'REGISTER_DISPLAY_AD';
export const REGISTER_DISPLAY_AD_FULFILLED = 'REGISTER_DISPLAY_AD_FULFILLED';
export const REGISTER_DISPLAY_AD_REJECTED = 'REGISTER_DISPLAY_AD_REJECTED';

export const RENDER_DISPLAY_AD_FOR_SLOT = 'RENDER_DISPLAY_AD_FOR_SLOT';
export const RENDER_DISPLAY_AD_FOR_SLOT_FULFILLED = 'RENDER_DISPLAY_AD_FOR_SLOT_FULFILLED';
export const RENDER_DISPLAY_AD_FOR_SLOT_REJECTED = 'RENDER_DISPLAY_AD_FOR_SLOT_REJECTED';

export const GET_DISPLAY_AD_FOR_SLOT = 'GET_DISPLAY_AD_FOR_SLOT';
export const GET_DISPLAY_AD_FOR_SLOT_FULFILLED = 'GET_DISPLAY_AD_FOR_SLOT_FULFILLED';
export const GET_DISPLAY_AD_FOR_SLOT_REJECTED = 'GET_DISPLAY_AD_FOR_SLOT_REJECTED';

export const CONFIGURE_ADS = 'CONFIGURE_ADS';
export const CONFIGURE_ADS_PENDING = 'CONFIGURE_ADS_PENDING';
export const CONFIGURE_ADS_FULFILLED = 'CONFIGURE_ADS_FULFILLED';
export const CONFIGURE_ADS_REJECTED = 'CONFIGURE_ADS_REJECTED';

export const CONFIGURE_PAGE_AD_SLOTS = 'CONFIGURE_PAGE_AD_SLOTS';
export const CONFIGURE_PAGE_AD_SLOTS_PENDING = 'CONFIGURE_PAGE_AD_SLOTS_PENDING';
export const CONFIGURE_PAGE_AD_SLOTS_FULFILLED = 'CONFIGURE_PAGE_AD_SLOTS_FULFILLED';
export const CONFIGURE_PAGE_AD_SLOTS_REJECTED = 'CONFIGURE_PAGE_AD_SLOTS_REJECTED';

export const GET_AD_CONFIG = 'GET_AD_CONFIG';
export const GET_AD_CONFIG_PENDING = 'GET_AD_CONFIG_PENDING';
export const GET_AD_CONFIG_FULFILLED = 'GET_AD_CONFIG_FULFILLED';
export const GET_AD_CONFIG_REJECTED = 'GET_AD_CONFIG_REJECTED';

export const DISPLAY_INFINITE_SCROLL_AD = 'DISPLAY_INFINITE_SCROLL_AD';

export const CLEAR_AD_REQUEST = 'CLEAR_AD_REQUEST';
export const REFRESH_AD = 'REFRESH_AD';

export function registerDisplayAdWidget(slotId)
{
    return {
        type: REGISTER_DISPLAY_AD,
        payload: registerDisplayAdWidgetBySlotId(slotId)
    };
}

async function registerDisplayAdWidgetBySlotId(slotId)
{
    const op = new DisplayAdProvider();
    return await op.registerDisplayAdWidgetBySlotId(slotId);
}

export function renderDisplayAdForSlot(slotId)
{
    return {
        type: GET_DISPLAY_AD_FOR_SLOT,
        payload: displayAdBySlotId(slotId)
    };
}

async function displayAdBySlotId(slotId, stdParameters)
{
    const op = new DisplayAdProvider();
    return await op.renderDisplayAdForSlot(slotId, stdParameters);
}

export function configureAds(globalAdConfig, adConfig, latitude,
    longitude,
    stationId,
    providerId,
    adServer,
    units,
    authId,
    secret,
    stdParameters,
    adTargetingBaseUrl,
    refresh=false,
    complianceRequirements
) {

    return async (dispatch) => {
        try {
            const verbose = false;
            const paramsResult = await dispatch(getAdTargetingParameters(adTargetingBaseUrl,
                authId,
                secret,
                verbose,
                stdParameters,
                latitude,
                longitude,
                stationId || '',
                providerId || '',
                adServer,
                units,
                refresh
            ));

            const targetingParameters = paramsResult.value && paramsResult.value.tp || {};
            adConfig.keywords = adConfig.keywords || {};
            adConfig.keywords = { ...adConfig.keywords, ...targetingParameters };

        } catch (error) {
        // eslint-disable-next-line no-console
            console.log('Error loading keyword data', error);
        }

        dispatch({
            type: CONFIGURE_ADS,
            payload: configureAdsAction(globalAdConfig, adConfig, complianceRequirements)
        });
    };
}

async function configureAdsAction(globalAdConfig, adConfig, complianceRequirements) {
    const op = new DisplayAdProvider();
    return await op.configureAds(globalAdConfig, adConfig, complianceRequirements);
}

export function configurePageAdSlots(pageId, pageAdConfig, globalAdConfig, latitude, longitude, currentScreenSize, activeRoute, cameraId) {
    return {
        type: CONFIGURE_PAGE_AD_SLOTS,
        payload: configurePageAdSlotsAction(pageId, pageAdConfig, globalAdConfig, latitude, longitude, currentScreenSize, activeRoute, cameraId)
    };
}

async function configurePageAdSlotsAction(pageId, pageAdConfig, globalAdConfig, latitude, longitude, currentScreenSize, activeRoute, cameraId) {
    const op = new DisplayAdProvider();
    return await op.configurePageSlots(pageId, pageAdConfig, globalAdConfig, latitude, longitude, currentScreenSize, activeRoute, cameraId);
}

export function getAdConfig(authId, secret) {
    return {
        type: GET_AD_CONFIG,
        payload: getAdConfigAction(authId, secret)
    };
}

async function getAdConfigAction(authId, secret) {
    const op = new DisplayAdProvider();
    return await op.getAdConfig(authId, secret);
}

export function clearAdRequest() {
    clearAdRequestAction();
    return {
        type: CLEAR_AD_REQUEST
    };
}

function clearAdRequestAction() {
    const op = new DisplayAdProvider();
    op.clearAdRequest();
}

export function refreshAd(slotId, pageId, globalAdConfig) {
    refreshAdAction(slotId, pageId, globalAdConfig);
    return {
        type: REFRESH_AD
    };
}

async function refreshAdAction(slotId, pageId, globalAdConfig) {
    const op = new DisplayAdProvider();
    return await op.refreshAd(slotId, pageId, globalAdConfig);
}

export function displayInfiniteScrollAd(slotId, adConfig, globalAdConfig) {
    displayInfiniteScrollAdAction(slotId, adConfig, globalAdConfig);
    return {
        type: REFRESH_AD
    };
}

function displayInfiniteScrollAdAction(slotId, adConfig, globalAdConfig) {
    const op = new DisplayAdProvider();
    op.displayInfiniteScrollAdAction(slotId, adConfig, globalAdConfig);
}
